(ns frontend.view.reports.custom.alj-2.utils
  (:require
   [frontend.ui.component.date-range-picker.view :refer
    [date-range-dropdown
     date-range-picker
     from-2018-to-today
     this-quarter-to-date]]
   [frontend.utils :as fu]
   [reagent.core :as r]))


(defn ticket-size-sum
  [deals]
  (->> deals
       (mapv :oppo/cur-ticket)
       (mapv fu/bigdec->float)
       (apply +)))


(defn ticket-size-sum-millions
  [deals]
  (let [sum (ticket-size-sum deals)
        temp (/ sum 10000)
        rounded (.round js/Math temp)]
    (/ rounded 100)))

(defn ticket-size-sum-billions
  [deals]
  (let [sum (ticket-size-sum deals)
        temp (/ sum 10000)
        rounded (.round js/Math temp)]
    (.toFixed (/ rounded 100000) 1)))


; Todo - ask what ALJ wants as default
(defn default-date-range-state
  [from-state]
  (let [[start end] (from-2018-to-today)]
    (if from-state
      (select-keys @from-state [:start-ts :end-ts :range-kw])
      {:start-ts (.getTime start)
       :end-ts   (.getTime end)
       :range-kw :all-time})))



(defn deals-in-date-range
  [date-field-kw date-config deals]
  (let [{:keys [start-ts end-ts]} date-config]
    (->> deals
         (filter (fn [deal]
                   (let [dt (get deal date-field-kw)]
                     (and (<= start-ts dt)
                          (>= end-ts dt))))))))


(defn deals-in-date-range-if-configured
  [date-field-kw date-config date-kw config-field deals]
  (let [{:keys [start-ts end-ts in-use]} (get date-config date-kw)]
    (when (= config-field :oppo.status/ok)
      (js/console.log "Config ?  " (get date-config date-kw)))
    (if-not (some #{config-field} in-use)
      deals
      (->> deals
           (filter (fn [deal]
                     (let [dt (get deal date-field-kw)]
                       (and (<= start-ts dt)
                            (>= end-ts dt)))))))))

(defn date-state-defaults
  [state default-configs]
  (r/atom (merge {:collapsed? true}
                 (->> default-configs
                      (map (fn [[k in-use applied-kws]]
                             (assert (some #{k} [:date-created :date-passed :date-portfolio :date-cic]) "Not proper date kw")
                             [k
                              (assoc (get @state k)
                                     :in-use in-use
                                     :applied-kws applied-kws)]))
                      (into {})))))

(defn ^{:jsdoc ["@nocollapse"]} million-format-with-separators
  [_]
  (this-as js-data-point
           (let [point (js->clj js-data-point
                                :keywordize-keys
                                true)
                 value (:y point)]
             (str "<b>"
                  (fu/number-string->thousand-separators
                   (fu/format "%.1f" (fu/round (/ (Math/abs value) 1) 2))
                   ","
                   ".")
                  "M</b>"))))

